'use client';

import MuiContainer from '@new-components/atoms/MuiContainer';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiTypography from '@new-components/atoms/MuiTypography';

import TestimonialsOnExperiencesCarousel from '@new-components/organisms/TestimonialsOnExperiencesSlider';

import {CssVariables, MediaQuery} from '@constants/theme';

import {TestimonialsOnExperiencesPropsTypes} from './types';

const TestimonialsOnExperiences = ({
  title,
  userExperinces,
}: TestimonialsOnExperiencesPropsTypes): JSX.Element => {
  return (
    <MuiContainer
      style={{paddingLeft: '0', paddingRight: '0'}}
      sx={{
        padding: 0,
        paddingTop: 4,
        paddingBottom: 8,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        [MediaQuery.desktop]: {
          paddingTop: 8,
          paddingBottom: 8,
        },
      }}>
      <MuiBox
        sx={{
          padding: `0 var(${CssVariables.mobilePadding})`,
        }}>
        <MuiBox
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            [MediaQuery.mobile]: {
              alignItems: 'start',
              marginLeft: 0.5,
            },
          }}>
          <MuiTypography
            sx={{
              color: '#2D2D2D',
              fontSize: '24px',
              fontWeight: 400,
              lineHeight: '125%',
              letterSpacing: '-0.4px',
              [MediaQuery.desktop]: {
                fontSize: '48px',
                fontWeight: 300,
                lineHeight: '110%',
                letterSpacing: '-0.8px',
              },
            }}>
            {title}
          </MuiTypography>
        </MuiBox>
        <MuiBox
          sx={{
            'width': '100%',
            'overflow': 'hidden',
            // Hide react-slick's default arrows completely
            '& .slick-prev, & .slick-next': {
              display: 'none !important',
            },
          }}>
          <TestimonialsOnExperiencesCarousel userExperinces={userExperinces} />
        </MuiBox>
      </MuiBox>
    </MuiContainer>
  );
};

export default TestimonialsOnExperiences;
